import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// Usage: data-controller="duplicate-program-modal"
// Handles duplication of funding programs with custom name
export default class extends Controller {
  static targets = ["modal", "form", "programName", "nameInput"];
  static values = {
    baseUrl: String
  };

  connect() {
    if (this.hasModalTarget) {
      this.modalTarget.addEventListener('hidden.bs.modal', this._handleModalHidden.bind(this));
    }
  }

  disconnect() {
    if (this.hasModalTarget) {
      this.modalTarget.removeEventListener('hidden.bs.modal', this._handleModalHidden.bind(this));
    }
  }

  open(event) {
    event.preventDefault();
    
    const programId = event.currentTarget.dataset.programId;
    const programName = event.currentTarget.dataset.programName;
    
    // Update the form action URL
    const formUrl = this.baseUrlValue.replace(':id', programId);
    this.formTarget.action = formUrl;
    
    // Update the program name in the modal
    this.programNameTarget.textContent = programName;
    
    // Pre-fill the input with a suggested name
    this.nameInputTarget.value = `${programName} (Copy)`;
    
    // Show the modal using Bootstrap
    const modal = new Modal(this.modalTarget);
    modal.show();
    
    // Focus and select the input after modal is shown
    this.modalTarget.addEventListener('shown.bs.modal', () => {
      this.nameInputTarget.focus();
      this.nameInputTarget.select();
    }, { once: true });
  }

  _handleModalHidden() {
    // Reset the input
    this.nameInputTarget.value = '';
  }
}
